import { cn } from '@/lib/utils';
import type { PropertyStatus } from '@/lib/types';

export const STATUS_STYLE: Record<PropertyStatus, { dot: string; tag: string; rail: string; soft: string }> = {
	出售: {
		dot: 'bg-sale',
		tag: 'border-orange-300 bg-orange-100 text-orange-900',
		rail: 'border-l-sale',
		soft: 'bg-orange-100/80',
	},
	出租: {
		dot: 'bg-rent',
		tag: 'border-blue-300 bg-blue-100 text-blue-900',
		rail: 'border-l-rent',
		soft: 'bg-blue-100/80',
	},
	已售: {
		dot: 'bg-sold',
		tag: 'border-zinc-300 bg-zinc-200 text-zinc-800',
		rail: 'border-l-sold',
		soft: 'bg-zinc-100',
	},
	已租: {
		dot: 'bg-sold',
		tag: 'border-zinc-300 bg-zinc-200 text-zinc-800',
		rail: 'border-l-sold',
		soft: 'bg-zinc-100',
	},
};

export function StatusTag({ status, className }: { status: PropertyStatus; className?: string }) {
	const s = STATUS_STYLE[status] ?? STATUS_STYLE['出售'];
	return (
		<span className={cn('inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[15.5px] font-semibold leading-tight', s.tag, className)}>
			<span className={cn('w-1.5 h-1.5 rounded-full', s.dot)} />
			{status}
		</span>
	);
}

export function ActiveTag({ active }: { active: boolean }) {
	return (
		<span
			className={cn(
				'inline-block px-2 py-0.5 rounded-full text-[14.5px] leading-tight',
				active ? 'border border-green-300 bg-green-100 text-accent' : 'border border-zinc-300 bg-zinc-200 text-zinc-600'
			)}
		>
			{active ? '有效' : '无效'}
		</span>
	);
}
